export default function returntypeof<RT>(expression: (...params: any[]) => RT): RT {
  return {} as RT;
}


// WEBPACK FOOTER //
// ./src/lib/helper/returntypeof.ts